import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InicioComponent } from './pages/inicio/inicio.component';
import { ProductosComponent } from './pages/productos/productos.component';
import { ProductoComponent } from './pages/producto/producto.component';
import { ComprasComponent } from './pages/compras/compras.component';
import { AdministracionComponent } from './administrador/administracion/administracion.component';
import { MenuComponent } from './administrador/menu/menu.component';
import { SolicitudesComponent } from './administrador/solicitudes/solicitudes.component';
import { GestionProductosComponent } from './administrador/gestion-productos/gestion-productos.component';
import { FilterPipe } from './pipes/filter.pipe';
import { NuevoProductoComponent } from './administrador/nuevo-producto/nuevo-producto.component';
import { RegistroComponent } from './pages/registro/registro.component';
import { ClientesComponent } from './administrador/clientes/clientes.component';
import {NgxPrintModule} from 'ngx-print';
import { PedidosComponent } from './pages/pedidos/pedidos.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { EditarProductoComponent } from './administrador/editar-producto/editar-producto.component';
import { ContrasenaComponent } from './pages/contrasena/contrasena.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    InicioComponent,
    ProductosComponent,
    ProductoComponent,
    ComprasComponent,
    AdministracionComponent,
    MenuComponent,
    SolicitudesComponent,
    GestionProductosComponent,
    FilterPipe,
    NuevoProductoComponent,
    RegistroComponent,
    ClientesComponent,
    PedidosComponent,
    PerfilComponent,
    EditarProductoComponent,
    ContrasenaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPrintModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
